import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useMsal } from "@azure/msal-react";
import { getApiToken } from '../../utils/authUtils.js';
import { createStore } from 'devextreme-aspnet-data-nojquery';

import './athlete_medical_overview.scss';

import {
    DataGrid,
    Column,
    Scrolling,
    SearchPanel,
    Toolbar,
    Item,
    HeaderFilter,
    LoadPanel,
    Sorting
} from 'devextreme-react/data-grid';
import Button from 'devextreme-react/button';
import { useNavigate } from 'react-router-dom';

const cellNameRender = (cell) => (
    <div>{cell.data.lastname}, {cell.data.surname}</div>
);

export const AthleteMedicalOverview = () => {
    const { instance, accounts } = useMsal();
    const [gridDataSource, setGridDataSource] = useState();
    const [dataSourceClub, setDataSourceClub] = useState();
    const [dataSourceTrainingGroup, setDataSourceTrainingGroup] = useState();
    const gridRef = useRef(null);
    const navigate = useNavigate();
    
    const onLeftClick = () => {
        navigate(-1);
    };

    const onRowClick = useCallback(({ data }) => {
        const athleteId = data.athleteId;
        navigate(`/athlete/edit/${athleteId}`);
    }, [navigate]);

    useEffect(() => {
        getApiToken(instance, accounts).then(token => {
            // Berechne das Datum von vor einem Jahr
            const oneYearAgo = new Date();
            oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1);

            // Athletes DataSource
            setGridDataSource({
                store: createStore({
                    key: 'athleteId',
                    loadUrl: `${process.env.REACT_APP_serverEndpoint}/Athlete/Athletes`,
                    onBeforeSend: (method, ajaxOptions) => {
                        ajaxOptions.headers = {
                            'Authorization': "Bearer " + token
                        };
                    },
                }),
                filter: [
                    ['status', '=', 'Aktiv'],
                    'and',
                    [
                        ['Medicalcertificate', '<', oneYearAgo],
                        'or',
                        ['Medicalcertificate', '=', null]
                    ]
                ]
            });

            // Club DataSource
            const clubStore = createStore({
                key: 'clubId',
                loadUrl: `${process.env.REACT_APP_serverEndpoint}/Club/ClubsBasic`,
                onBeforeSend: (method, ajaxOptions) => {
                    ajaxOptions.headers = {
                        'Authorization': "Bearer " + token
                    };
                },
            });
            setDataSourceClub(clubStore);

            // Training Group DataSource
            const trainingGroupStore = createStore({
                key: 'traininggroupId',
                loadUrl: `${process.env.REACT_APP_serverEndpoint}/Traininggroup/TraininggroupsBasic`,
                onBeforeSend: (method, ajaxOptions) => {
                    ajaxOptions.headers = {
                        'Authorization': "Bearer " + token
                    };
                },
            });
            setDataSourceTrainingGroup(trainingGroupStore);
        });
    }, [instance, accounts]);

    const refresh = () => {
        if (gridRef.current) {
            gridRef.current.instance().refresh();
        }
    };

    return (
        <div className='view athlete-medical-overview'>
            <div className='view-wrapper view-wrapper-athlete-medical-overview list-page'>
                <DataGrid
                    className='grid theme-dependent'
                    noDataText=''
                    focusedRowEnabled
                    height='100%'
                    dataSource={gridDataSource}
                    allowColumnReordering
                    showBorders
                    ref={gridRef}
                    remoteOperations={true}
                    onRowClick={onRowClick}
                >
                    <LoadPanel showPane={false} />
                    <SearchPanel visible placeholder='Sportler suchen' />
                    <HeaderFilter visible />
                    <Sorting mode='multiple' />
                    <Scrolling mode='virtual' />
                    
                    <Toolbar>
                        <Item location='before'>
                            <Button icon='arrowleft' stylingMode='text' onClick={onLeftClick} />
                        </Item>
                        <Item location='before'>
                            <div className='grid-header'>Medizinische Untersuchung - Übersicht</div>
                        </Item>
                        <Item
                            location='after'
                            locateInMenu='auto'
                            showText='inMenu'
                            widget='dxButton'
                        >
                            <Button
                                icon='refresh'
                                text='Refresh'
                                stylingMode='text'
                                onClick={refresh}
                            />
                        </Item>
                        <Item location='after' locateInMenu='auto'>
                            <div className='separator' />
                        </Item>
                        <Item name='searchPanel' locateInMenu='auto' />
                    </Toolbar>

                  
                    <Column
                        dataField='lastname'
                        caption='Name'
                        sortOrder='asc'
                        hidingPriority={6}
                        minWidth={150}
                        cellRender={cellNameRender}
                        dataType='string'
                    />
                    <Column
                        dataField='surname'
                        caption='Vorname'
                        visible={false}
                        dataType='string'
                    />
                    <Column 
                        dataField='dateofbirth' 
                        caption='Geburtsdatum' 
                        dataType='date' 
                        format='dd.MM.yyyy' 
                        hidingPriority={4}
                        allowHiding={true}
                    />
                    <Column 
                        dataField='medical' 
                        caption='Medizinische Untersuchung' 
                        dataType='date' 
                        format='dd.MM.yyyy' 
                        hidingPriority={5}
                        allowHiding={true}
                    />
                    <Column 
                        dataField='traininggroupId' 
                        caption='Trainingsgruppe' 
                        dataType='string'
                        hidingPriority={2}
                        allowHiding={true}
                        lookup={{ 
                            dataSource: dataSourceTrainingGroup, 
                            valueExpr: 'traininggroupId', 
                            displayExpr: 'groupname' 
                        }}
                    />
                    <Column 
                        dataField='clubId' 
                        caption='Verein' 
                        dataType='string'
                        hidingPriority={3}
                        allowHiding={true}
                        lookup={{ 
                            dataSource: dataSourceClub, 
                            valueExpr: 'clubId', 
                            displayExpr: 'shortclubname' 
                        }}
                    />
                </DataGrid>
            </div>
        </div>
    );
};
